import React from 'react';
import { RetrieveRequest } from '../../../utilities/services/RequestService';
import { getOptionsDeactive } from '../../../utilities/actions/Helpers';
import { Alert } from '../..';
import SelectBase from './SelectBase';
import { api } from '../../../config/Services';

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            options: []
        }
    }

    componentDidMount() {
        if (this.props.forceRender) {
            this.retrieveData();
        }
    }

    retrieveData(inactivefield = {}, actionspage = 'create', specialLabel) {
        let url = api.url.partnervoucher.partner.retrieve;
        let criteria = { active: true };
        let sort = { partnername: 'asc' };
        let paging = { limit: -1, page: 1 };
        this.setState({ isLoading: true });
        RetrieveRequest(url, criteria, sort, paging).then((response) => {
            const { status = {} } = response || {};
            if (status.responsecode === '0000') {
                var options = response.result.map(({ partnername, partnercode }) => {
                    if (specialLabel) {
                        return {
                            label: `${partnercode} - ${partnername}`,
                            value: partnercode
                        };
                    } else {
                        return {
                            label: partnername,
                            value: partnercode
                        };
                    }
                });

                //if options deactive
                const { partnercode, partnername } = inactivefield;
                if (partnercode) {
                    options = getOptionsDeactive(actionspage, options, partnercode, partnername);
                }

                this.setState({ options, isLoading: false });
            } else {
                Alert.error(response.status.responsemessage);
            }
        });
    }

    render() {
        return (<SelectBase {...this.props} options={this.state.options} isLoading={this.state.isLoading} />)
    }
}

export default App;